import { combineReducers } from 'redux';
import training from './training.reducer';

const reducer = combineReducers({
	training
});

export default reducer;
